import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "./UserMarkerInfoWindow.module.scss";

export const UserMarkerInfoWindow = () => {
  const { __ } = useTranslations();
  return (
    <div className={styles.infoWindowContentWrapper}>
      <span className={styles.infoWindowText}>{__("storelocator.user_location.infowindow.label")}</span>
    </div>
  );
};
